export default __webpack_public_path__ + "static/media/Bloomberg_dark2.edc16aff.svg";